import { graphClient } from '../../../graph-client'
import { UPDATE_USER_TASK_SPECTATOR_RESCUED } from './gql'
import type { RescuedSpectatorTask } from './types'

class UserTaskSpectatorRescued {
  async rescued(params: RescuedSpectatorTask.Input) {
    const request = await graphClient.request<RescuedSpectatorTask.Output>(
      UPDATE_USER_TASK_SPECTATOR_RESCUED,
      params,
    )

    return request?.updateUserTaskSpectatorRescued
  }
}

export const userTaskSpectatorRescuedService = new UserTaskSpectatorRescued()
